import React, { useState } from "react";
import { motion } from "framer-motion";
import { Gavel, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "sonner";
import { Dialog } from "@/components/ui/dialog";
import RegisterDialog from "@/components/auth/RegisterDialog";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const CTACallSection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData = labels.menuPages?.buyCar?.ctaCallSection || {};
  const statsData = sectionData.stats || [];
  const { isAuthenticated } = useAuth();
  const [showRegisterDialog, setShowRegisterDialog] = useState(false);

  const handleCreateAccount = () => {
    if (isAuthenticated) {
      toast.error(
        sectionData.alreadyLoggedIn ||
          "Du är redan inloggad. Logga ut för att kunna skapa nytt konto.",
      );
      return;
    }
    setShowRegisterDialog(true);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="text-center mb-12 md:mb-16"
    >
      <div className="bg-gradient-to-br from-green-500 to-teal-600 rounded-2xl md:rounded-3xl p-8 md:p-12 text-white">
        <h3 className="text-2xl md:text-3xl lg:text-5xl font-bold mb-3 md:mb-4">
          {sectionData.title || "Redo Att Hitta Din Drömbil?"}
        </h3>
        <p className="text-base md:text-lg lg:text-xl text-gray-200 mb-6 md:mb-8 px-4">
          {sectionData.description ||
            "Gå med i tusentals nöjda kunder som redan köpt sin bil genom våra auktioner."}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8 md:mb-12 px-4">
          <Button
            size="lg"
            onClick={handleCreateAccount}
            className="text-base md:text-lg px-6 md:px-8 py-4 md:py-6 bg-white text-green-600 hover:bg-gray-100 rounded-full font-semibold transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            <Gavel className="mr-2 w-4 h-4 md:w-5 md:h-5" />
            {sectionData.button || "Skapa Konto & Börja Buda"}
            <ArrowRight className="ml-2 w-4 h-4 md:w-5 md:h-5" />
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {statsData.map((stat: any, index: number) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: (index + 1) * 0.1 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <div className="text-2xl md:text-4xl font-bold mb-1 md:mb-2">
                {stat.value || ""}
              </div>
              <div className="text-sm md:text-lg">{stat.label || ""}</div>
            </motion.div>
          ))}
        </div>
      </div>

      <Dialog open={showRegisterDialog} onOpenChange={setShowRegisterDialog}>
        <RegisterDialog
          open={showRegisterDialog}
          onClose={() => setShowRegisterDialog(false)}
        />
      </Dialog>
    </motion.div>
  );
};

export default CTACallSection;
